import {getRequest, postRequest} from '../../../../middlewares/api/actions';
import {
    getConfiguredPluginsURL,
    getCsvHeaderUrl,
    getCubeUrl,
    getFileMappingUrl,
    getCalcFieldUrl,
    getCalcFieldDetailUrl,
    getDeleteCalcFieldUrl,
    getCreateTempTableUrl,
    getDeleteTempTableUrl
} from '../../../../constants/urls';
import { cubeComponentTypes } from './utils';
import {submitPluginConvertAction} from "../../../utilities/plugins/actions";
import moment from 'moment';

export const FILE_MAPPING_WIZARD_SHOW = 'FILE_MAPPING_WIZARD_SHOW';
export const FILE_MAPPING_WIZARD_HIDE = 'FILE_MAPPING_WIZARD_HIDE';
export const FILE_MAPPING_WIZARD_CSV_HEADER_GET = 'FILE_MAPPING_WIZARD_CSV_HEADER_GET';
export const FILE_MAPPING_WIZARD_CALC_FIELD_GET = 'FILE_MAPPING_WIZARD_CALC_FIELD_GET';
export const FILE_MAPPING_WIZARD_CUBE_READ = 'FILE_MAPPING_WIZARD_CUBE_READ';
export const FILE_MAPPING_WIZARD_COLUMN_SELECT = 'FILE_MAPPING_WIZARD_COLUMN_SELECT';
export const FILE_MAPPING_WIZARD_FILE_MAPPING_CREATE = 'FILE_MAPPING_WIZARD_FILE_MAPPING_CREATE';
export const FILE_MAPPING_WIZARD_STEP_SET = 'FILE_MAPPING_WIZARD_STEP_SET';
export const FILE_MAPPING_WIZARD_FORM_CHANGE = 'FILE_MAPPING_WIZARD_FORM_CHANGE';
export const FILE_MAPPING_WIZARD_CUBE_COMPONENTS_SHOW = 'FILE_MAPPING_WIZARD_CUBE_COMPONENTS_SHOW';
export const FILE_MAPPING_WIZARD_CUBE_COMPONENTS_HIDE = 'FILE_MAPPING_WIZARD_CUBE_COMPONENTS_HIDE';
export const FILE_MAPPING_WIZARD_COMPONENTS_SHOW = 'FILE_MAPPING_WIZARD_COMPONENTS_SHOW';
export const FILE_MAPPING_WIZARD_COMPONENTS_HIDE = 'FILE_MAPPING_WIZARD_COMPONENTS_HIDE';
export const FILE_MAPPING_WIZARD_PLUGIN_TO_CSV_CONVERT = 'FILE_MAPPING_WIZARD_PLUGIN_TO_CSV_CONVERT';
export const FILE_MAPPING_WIZARD_PLUGINS_GET = 'FILE_MAPPING_WIZARD_PLUGINS_CONVERT';
export const FILE_MAPPING_WIZARD_CHECK_MANDATORY_FIELDS = 'FILE_MAPPING_WIZARD_CHECK_MANDATORY_FIELDS';
export const FILE_MAPPING_WIZARD_CHECK_CIRCULAR_DEPENDENCIES = 'FILE_MAPPING_WIZARD_CHECK_CIRCULAR_DEPENDENCIES?';
export const FILE_MAPPING_WIZARD_RESET_FIELDS = 'FILE_MAPPING_WIZARD_RESET_FIELDS';
export const FILE_MAPPING_WIZARD_DELETE_CALC_FIELD = 'FILE_MAPPING_WIZARD_DELETE_CALC_FIELD';
export const FILE_MAPPING_WIZARD_EDIT_CALC_FIELD_SHOW = 'FILE_MAPPING_WIZARD_EDIT_CALC_FIELD_SHOW';
export const FILE_MAPPING_WIZARD_DELETE_DEPENDENCY_ERROR_HIDE = 'FILE_MAPPING_WIZARD_DELETE_DEPENDENCY_ERROR_HIDE';
export const FILE_MAPPING_WIZARD_CSV_FORM_CREATE_TEMP_TABLE = 'FILE_MAPPING_WIZARD_CSV_FORM_CREATE_TEMP_TABLE';
export const FILE_MAPPING_WIZARD_DELETE_TEMP_TABLE = 'FILE_MAPPING_WIZARD_DELETE_TEMP_TABLE';
export const FILE_MAPPING_WIZARD_MODAL_CREATE_TEMP_TABLE_SHOW = 'FILE_MAPPING_WIZARD_MODAL_CREATE_TEMP_TABLE_SHOW';
export const FILE_MAPPING_WIZARD_MODAL_CREATE_TEMP_TABLE_HIDE = 'FILE_MAPPING_WIZARD_MODAL_CREATE_TEMP_TABLE_HIDE';

export const showFileMappingWizard = (cubeId, cubeCode) => ({
  type: FILE_MAPPING_WIZARD_SHOW,
  cubeId,
  cubeCode
});

export const hideFileMappingWizard = () => ({
  type: FILE_MAPPING_WIZARD_HIDE
});

export const deleteTempTable = tempTableName => ({
  ...postRequest(
    FILE_MAPPING_WIZARD_DELETE_TEMP_TABLE,
    getDeleteTempTableUrl(tempTableName)
  )
});

export const changeFileMappingWizardForm = fields => ({
  type: FILE_MAPPING_WIZARD_FORM_CHANGE,
  fields
});

export const getFileMappingWizardCsvHeader = (csvSeparator, csvDelimiter, csvHasHeader, csvServerPath, csvHasDotStatFormat, mode = null) => ({
  ...getRequest(
    FILE_MAPPING_WIZARD_CSV_HEADER_GET,
    getCsvHeaderUrl(csvSeparator, csvDelimiter, csvHasHeader, csvServerPath, mode)
  ),
  csvHasDotStatFormat
});

export const getFileMappingWizardCalculatedField = (tableName) => ({
  ...getRequest(
    FILE_MAPPING_WIZARD_CALC_FIELD_GET,
    getCalcFieldUrl(tableName)
  )
});

export const readFileMappingWizardCube = cubeId => getRequest(
  FILE_MAPPING_WIZARD_CUBE_READ,
  getCubeUrl(cubeId)
);

export const selectFileMappingWizardColumn = (columnName, originalColumnName, tempTableName) => ({
  type: FILE_MAPPING_WIZARD_COLUMN_SELECT,
  columnName,
  originalColumnName,
  tempTableName
});

export const createFileMappingWizardFileMapping = (name, description, tid, cubeId, components, csvForm, xmlServerPath,processFilePath, pluginUid, icon, iconColor, sequenceMapping, mergedHeader) => postRequest(
  FILE_MAPPING_WIZARD_FILE_MAPPING_CREATE,
  getFileMappingUrl(),
  {
    Name: name,
    Description: description !== null && description.length > 0 ? description : null,
    Tid: tid !== null && tid.length > 0 ? tid : null,
    IDCube: cubeId,
    Components: components.map(comp => ({
      ColumnName: comp.ColumnName,
      ColumnAlias: comp.ColumnAlias,
      CubeComponentCode: comp.CubeComponentCode,
      CubeComponentType: cubeComponentTypes[comp.CubeComponentType],
      MappingType: comp.MappingType,
      Expression: comp.Expression 
        ? comp.Expression
        : null,
      TempTable: comp.TempTable
        ? comp.TempTable
        : null
    })), 
    CSVDelimiter: csvForm.delimiter,
    CSVSeparator: csvForm.separator,
    HasHeader: csvForm.hasHeader,
    HasSpecialTimePeriod: csvForm.hasDotStatFormat,
    XMLFilePath: xmlServerPath,
    ProcessFilePath: processFilePath,
    PluginId: pluginUid,
    IconName: icon,
    IconColor: iconColor,
    SequenceMapping: sequenceMapping,
    Fields: mergedHeader.filter(field => !field.added && field.originalName !== '').map(function(field) {
      return {
        ColumnName: field.originalName !== '' ? field.originalName : field.name,
        ColumnAlias: field.originalName !== '' ? field.name : ''
      }
    }
    ),
  },
  t => ({
    start: t('scenes.dataManager.fileMapping.wizard.messages.fileMappingCreate.start'),
    success: t('scenes.dataManager.fileMapping.wizard.messages.fileMappingCreate.success')
  })
);

export const setFileMappingWizardStep = step => ({
  type: FILE_MAPPING_WIZARD_STEP_SET,
  step
});

export const showFileMappingWizardCubeComponents = () => ({
  type: FILE_MAPPING_WIZARD_CUBE_COMPONENTS_SHOW
});

export const hideFileMappingWizardCubeComponents = () => ({
  type: FILE_MAPPING_WIZARD_CUBE_COMPONENTS_HIDE
});

export const showFileMappingWizardComponents = () => ({
  type: FILE_MAPPING_WIZARD_COMPONENTS_SHOW
});

export const hideFileMappingWizardComponents = () => ({
  type: FILE_MAPPING_WIZARD_COMPONENTS_HIDE
});

export const convertFileMappingWizardPluginToCsv = (pluginUid, fileServerPath, transformFileServerPath, processFileServerPath, lang, outputExtension, dllName, cubeId) =>
    submitPluginConvertAction(pluginUid, fileServerPath, transformFileServerPath, processFileServerPath, lang, outputExtension, dllName, FILE_MAPPING_WIZARD_PLUGIN_TO_CSV_CONVERT, 2, cubeId);

export const getFileMappingWizardPlugin = (nodeId) => getRequest(
    FILE_MAPPING_WIZARD_PLUGINS_GET,
    getConfiguredPluginsURL(nodeId, "FileMapping")
);

export const checkMandatoryFields = () => ({
  type: FILE_MAPPING_WIZARD_CHECK_MANDATORY_FIELDS,
});

export const checkCircularDependencies = () => ({
  type: FILE_MAPPING_WIZARD_CHECK_CIRCULAR_DEPENDENCIES,
});

export const resetFields = () => ({
    type: FILE_MAPPING_WIZARD_RESET_FIELDS
});

export const onDeleteCalcField = (tableName, aliasQuery) => postRequest(
  FILE_MAPPING_WIZARD_DELETE_CALC_FIELD,
  getDeleteCalcFieldUrl(tableName),
  {
    PageNum: 0,
    PageSize: 0,
    FilterTable: [],
    SortCols: [],
    SortByDesc: false,
    SelCols: null,
    HasCalculatedField: true,
    CalculatedFieldName: aliasQuery,
    CalculatedFieldExpression: null
  },
)

export const editCalcField = (tableName, aliasQuery) => ({
  ...getRequest(
    FILE_MAPPING_WIZARD_EDIT_CALC_FIELD_SHOW,
    getCalcFieldDetailUrl(tableName, aliasQuery)
  )
});

export const hideDependencyError = () => ({
  type: FILE_MAPPING_WIZARD_DELETE_DEPENDENCY_ERROR_HIDE
})

export const createTempTable = (fileServerPath, separator, delimiter, mode = null) => {
  return postRequest(
    FILE_MAPPING_WIZARD_CSV_FORM_CREATE_TEMP_TABLE,
    getCreateTempTableUrl(fileServerPath, separator, delimiter, mode),
    fileServerPath,
    t => ({
      start: t('scenes.dataManager.fileMapping.wizard.enableCalcField.messages.submit.start'),
      success: t('scenes.dataManager.fileMapping.wizard.enableCalcField.messages.submit.success')
    })
  )
}

export const showModalTempTable = () => ({
  type: FILE_MAPPING_WIZARD_MODAL_CREATE_TEMP_TABLE_SHOW
})

export const hideModalTempTable = () => ({
  type: FILE_MAPPING_WIZARD_MODAL_CREATE_TEMP_TABLE_HIDE
})